export default {
    resolver: 'vue:resolver',
    registration: 'aurelia:registration',
    wrap: 'di:wrap',
    invoker: 'aurelia:invoker',
    resource: 'aurelia:resource',
    paramTypes: 'design:paramtypes',
    propertyType: 'design:type',
    inject: 'aurelia:inject',
    properties: 'design:properties',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDWCxRQUFRLEVBQUUsY0FBYztJQUN4QixZQUFZLEVBQUUsc0JBQXNCO0lBQ3BDLElBQUksRUFBRSxTQUFTO0lBQ2YsT0FBTyxFQUFFLGlCQUFpQjtJQUMxQixRQUFRLEVBQUUsa0JBQWtCO0lBQzVCLFVBQVUsRUFBRSxtQkFBbUI7SUFDL0IsWUFBWSxFQUFFLGFBQWE7SUFDM0IsTUFBTSxFQUFFLGdCQUFnQjtJQUN4QixVQUFVLEVBQUUsbUJBQW1CO0NBQ2xDLENBQUMifQ==